export const getCsType = (
  isCsCenter?: boolean | null,
  isCsCenterEmail?: boolean | null,
) =>
  [isCsCenter && '전화', isCsCenterEmail && '이메일'].filter(Boolean).join('/');

export default { getCsType };
